import { Checkbox } from '@clubspark-react/ui';
import { type Row, type Table } from '@tanstack/react-table';
import { type XYCoord } from 'react-dnd';

export type EnhancedTableClasses = 'toggle' | 'popover' | 'table' | 'pagination';
export type MUIReactTableClasses = 'container' | 'root' | 'header' | 'row' | 'headerCell';
export type TPaginationClasses = 'paginationCaption' | 'menuItem' | 'toolbar' | 'select' | 'action';
export type ColumnsMenuClasses = 'root' | 'menuItem' | 'item' | 'label' | 'control' | 'disableToggle' | 'unCheckbox';

export const defaultPaginationOptions = [
  { label: '25', value: 25 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
  { label: 'All', value: -1 },
];

export const getItemStyles = (initialOffset: XYCoord | null, currentOffset: XYCoord | null) => {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }

  const { x, y } = currentOffset;

  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
};

export const getSelectionColumnDefinition = () => ({
  id: 'selection',
  header: ({ table }: { table: Table<any> }) => {
    return (
      <Checkbox
        checked={table.getIsAllRowsSelected() || table.getIsSomeRowsSelected()}
        label=""
        value=""
        onChange={() => {
          table.toggleAllRowsSelected(!table.getIsAllRowsSelected());
        }}
      />
    );
  },
  cell: ({ row }: { row: Row<any> }) => {
    return (
      <Checkbox
        checked={row.getIsSelected() || row.getIsSomeSelected()}
        disabled={!row.getCanSelect()}
        label=""
        value=""
        onChange={row.getToggleSelectedHandler()}
      />
    );
  },
});
